import RootStore from './root-store';
export default RootStore;